<template>
    <div :class="item.container_class">
        <a v-if="item.link" :href="item.link" :title="item.title" :class="item.class"
            :target="item.link.startsWith('https') ? '_blank' : ''"
            class="cursor-pointer whitespace-nowrap btn-secondary">
            <span>{{ item.title }}</span>
            <MiniBadge v-if="item.badge" :label="item.badge" class="ml-2" />
            <Icon v-if="item.icon" :name="item.icon" :class="{ 'text-2xl': !item.title }" />
        </a>
        <div v-else :class="item.class">
            <span v-html="item.title || '&nbsp;'"></span>
            <MiniBadge v-if="item.badge" :label="item.badge" class="ml-2" />
        </div>

        <div v-if="item?.items?.length" :class="item.items_class">
            <HoverMenuItem2 :item="subitem" v-for="subitem in item.items" :key="subitem.title" />
        </div>
    </div>
</template>

<script lang="ts">
import type { TMenuItem } from '~/components/HoverMenu2.vue';


export default {
    props: {
        item: {
            type: Object as PropType<TMenuItem>,
            required: true,
        },
    },
}
</script>